import { jwtDecode } from "jwt-decode";

export const logout = () => {
    localStorage.removeItem("accessToken");
  };

  export const getCurrentUser = () => {
    const token = localStorage.getItem("accessToken");
    if (!token) return null;
  
    try {
      const decoded = jwtDecode(token);;
      return decoded;  // { user_id: ..., email: ... } が含まれる
    } catch (error) {
      console.error("トークンのデコードに失敗しました:", error);
      return null;
    }
  };